import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ThankYouDialog: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontSize: "21px",
          fontWeight: 600,
          textAlign: "center",
          paddingBottom: "10px",
          color: "#494440",
          fontFamily: '"Montserrat", Verdana, sans-serif',
        }}
      >
        Thank You
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "center",
            paddingBottom: "10px",
            color: "#494440",
            fontFamily: '"Montserrat", Verdana, sans-serif',
          }}
        >
          Your return request has been submitted to the branch for approval.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          paddingBottom: "15px",
        }}
      >
        <Button
          className="whiteButtonOutline"
          sx={{
            minWidth: 120,
            borderRadius: "4px",
            textTransform: "uppercase",
          }}
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankYouDialog;
